import { jsxs, jsx } from "react/jsx-runtime";
import { Entity } from "@contember/binding";
import { useClassName } from "@contember/react-utils";
import { Table, TableRow, TableCell } from "@contember/ui";
import { memo, useMemo } from "react";
import { DataGridHeaderCell } from "../DataGridHeaderCell.js";
import { dataGridDictionary } from "../dataGridDictionary.js";
import { getColumnFilter } from "../getColumnFilter.js";
import { useMessageFormatter } from "../../../../../../i18n/useMessageFormatter.js";
import { EmptyMessage } from "../../../helpers/EmptyMessage.js";
const DataGridContainerTable = memo(({
  accessor,
  desiredState,
  displayedState,
  emptyMessage,
  emptyMessageComponent,
  onEntityClick,
  selectedEntityIds,
  setFilter,
  setOrderBy
}) => {
  const {
    filterArtifacts,
    orderDirections,
    columns
  } = desiredState;
  const formatMessage = useMessageFormatter(dataGridDictionary);
  const onRowClick = useMemo(() => {
    if (!onEntityClick) {
      return void 0;
    }
    return (id) => {
      const entity = accessor.getChildEntityById(id);
      if (entity) {
        onEntityClick(entity);
      }
    };
  }, [accessor, onEntityClick]);
  return /* @__PURE__ */ jsxs(
    Table,
    {
      className: useClassName("data-grid-body-content--table"),
      tableHead: /* @__PURE__ */ jsx(TableRow, { children: Array.from(columns).filter(([columnKey]) => !desiredState.hiddenColumns[columnKey]).map(([columnKey, column]) => {
        const filterArtifact = filterArtifacts[columnKey];
        const orderDirection = orderDirections[columnKey];
        const orderColumns = Object.keys(orderDirections);
        return /* @__PURE__ */ jsx(
          DataGridHeaderCell,
          {
            environment: accessor.environment,
            filterArtifact,
            emptyFilterArtifact: column.enableFiltering !== false ? column.emptyFilter : null,
            orderState: orderDirection ? {
              direction: orderDirection,
              index: orderColumns.length > 1 ? orderColumns.indexOf(columnKey) : void 0
            } : void 0,
            setFilter: (newFilter) => setFilter(columnKey, newFilter),
            setOrderBy: (newOrderBy, append = false) => setOrderBy(columnKey, newOrderBy, append),
            headerJustification: column.headerJustification || column.justification,
            shrunk: column.shrunk,
            hasFilter: getColumnFilter(column, filterArtifact, accessor.environment) !== void 0,
            header: column.header,
            ascOrderIcon: column.ascOrderIcon,
            descOrderIcon: column.descOrderIcon,
            filterRenderer: column.enableFiltering !== false ? column.filterRenderer : void 0
          },
          columnKey
        );
      }) }),
      children: [
        !!accessor.length && Array.from(accessor, (entity) => /* @__PURE__ */ jsx(
          Entity,
          {
            accessor: entity,
            children: /* @__PURE__ */ jsx(TableRow, { id: entity.id, onClick: onRowClick, active: selectedEntityIds?.includes(entity.id), children: Array.from(columns).filter(([columnKey]) => !desiredState.hiddenColumns[columnKey]).map(([columnKey, column]) => {
              if (displayedState.hiddenColumns[columnKey]) {
                return /* @__PURE__ */ jsx(TableCell, { shrunk: true }, columnKey);
              }
              return /* @__PURE__ */ jsx(TableCell, { shrunk: column.shrunk, justification: column.justification, children: column.children }, columnKey);
            }) })
          },
          entity.key
        )),
        !accessor.length && /* @__PURE__ */ jsx(TableRow, { children: /* @__PURE__ */ jsx(TableCell, { colSpan: columns.size, children: /* @__PURE__ */ jsx(EmptyMessage, { border: false, component: emptyMessageComponent, children: formatMessage(emptyMessage, "dataGrid.emptyMessage.text") }) }) })
      ]
    }
  );
});
DataGridContainerTable.displayName = "DataGridContainerTable";
export {
  DataGridContainerTable
};
//# sourceMappingURL=DataGridContainerTable.js.map
